import React from 'react';
import { SignupLayout, SignupPaymentView } from '../components';
import { useSignupPaymentViewController } from '../controllers';

const SignupPaymentPage: React.FC = () => {
  const {
    companyId,
    selectedNumber,
    numberHeld,
    numberHeldUntil,
    holdRecovery,
    handedOver,
    chooseAnotherNumber,
    phase,
    busy,
    canRetry,
    error,
    pay,
    retry,
    dismissError,
  } = useSignupPaymentViewController();

  return (
    <SignupLayout>
      <SignupPaymentView
        companyId={companyId}
        selectedNumber={selectedNumber}
        numberHeld={numberHeld}
        numberHeldUntil={numberHeldUntil}
        holdRecovery={holdRecovery}
        handedOver={handedOver}
        phase={phase}
        busy={busy}
        canRetry={canRetry}
        error={error}
        onPay={pay}
        onRetry={retry}
        onRefusalStale={dismissError}
        onChooseAnotherNumber={chooseAnotherNumber}
      />
    </SignupLayout>
  );
};

export default SignupPaymentPage;
